module.exports = __webpack_public_path__ + "static/media/eBar.ee397e6f.jpg";